<template>

<div id="cat_form">

<!-- inputy katalizator -->
<!-- v-show bo v-if resetowalo formularz z plikami -->
<div class="screen_cat" v-show="current_screen == 'car'">

    <div class="single_page__form_item" :class="{ 'invalid': errors.has('car_brand') }" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right">
        <label class="blue" for="car_brand">{{lang.valuation_form_marka}}</label>
        <input type="text" name="car_brand" id="car_brand"  v-model="car_brand" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :class="{ 'invalid': errors.has('car_number') }" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right">
        <label class="blue" for="car_number">{{lang.valuation_form_number}}</label>
        <input type="text" name="car_number" id="car_number"  v-model="car_number" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :class="{ 'invalid': errors.has('car_model') }" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right">
        <label class="blue" for="car_model">{{lang.valuation_form_model}}</label>
        <input type="text" name="car_model" id="car_model" v-model="car_model" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :class="{ 'invalid': errors.has('car_weight') }" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right">
        <label class="blue" for="car_weight">{{lang.valuation_form_weight}}</label>
        <input type="text" name="car_weight" id="car_weight"  v-model="car_weight" v-validate="'required'">
    </div>

    <dropzone ref="dropzone_ref" id="myVueDropzone" :url="endpoint_url" accepted-file-types="image/*" :max-file-size-in-m-b="10"
     :max-number-of-files="10" v-on:vdropzone-success="uploaded_file" v-on:vdropzone-removed-file="remove_file" v-on:vdropzone-sending="sending_file" :language="dropzone_translation">
        <!-- Optional parameters if any! -->
    </dropzone>

    <div class="single_page__form_buttons">
      <button id="single_page__next" @click="to_second_screen" class="single_page__button">{{lang.valuation_next}}</button>
    </div>

</div>



<!-- inputy klient -->
<div class="screen_client" v-show="current_screen == 'client'">

    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_date') }">
      <label class="silver" for="form_date">{{lang.valuation_form_date}}</label>
      <date-picker :date="date" :option="datepicker_options" data-vv-name="client_date" data-vv-value-path="computedDate" v-validate="'required'"></date-picker>
    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_city') }">
        <label class="silver" for="client_city">{{lang.valuation_form_city}}</label>
        <input type="text" name="client_city" id="client_city" v-model="client_city" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_name') }">
        <label class="silver" for="client_name">{{lang.valuation_form_name}}</label>
        <input type="text" name="client_name" id="client_name" v-model="client_name" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_country') }">
        <label class="silver" for="form_country">{{lang.valuation_form_country}}</label>



 <multiselect v-model="select_country" :options="select_options" :close-on-select="true" :show-labels="true" placeholder="Wybierz kraj"  label="label" track-by="label" :selectLabel="lang.cat_form_select_label" deselectLabel="" :allowEmpty="false" :selectedLabel="lang.cat_form_country_selected"></multiselect>
  <pre class="language-json"><code>{{ country_code  }}</code></pre>



    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_street') }">
        <label class="silver" for="client_street">{{lang.valuation_form_street}}</label>
        <input type="text" name="client_street" id="client_street" v-model="client_street" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_street_number') }">
        <label class="silver" for="client_street_number">{{lang.valuation_form_street_number}}</label>
        <input type="text" name="client_street_number" id="client_street_number" v-model="client_street_number" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_postal_code') }">
        <label class="silver" for="client_postal_code">{{lang.valuation_form_postal_code}}</label>
        <input type="text" name="client_postal_code" id="client_postal_code" v-model="client_postal_code" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_document_number') }">
        <label class="silver" for="client_document_number">{{lang.valuation_form_passport_number}}</label>
        <input type="text" name="client_document_number" id="client_document_number" v-model="client_document_number" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_document_issued') }">
        <label class="silver" for="client_document_issued">{{lang.valuation_form_gifted}}</label>
        <input type="text" name="client_document_issued" id="client_document_issued" v-model="client_document_issued" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_required_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_phone') }">
        <label class="silver" for="client_phone">{{lang.valuation_form_phone}}</label>
        <input type="text" name="client_phone" id="client_phone" v-model="client_phone" v-validate="'required'">
    </div>
    <div class="single_page__form_item" :data-balloon="lang.valuation_form_email_error" data-balloon-pos="right" :class="{ 'invalid': errors.has('client_email') }">
        <label class="silver" for="client_email">{{lang.valuation_form_email}}</label>
        <input type="text" name="client_email" id="client_email" v-model="client_email" v-validate="'email|required'" :class="{ 'invalid': errors.has('form_email') }">
    </div>

    <!-- guziki -->
    <div class="single_page__form_buttons">
        <button id="single_page__back" @click="to_first_screen" class="single_page__button">{{lang.valuation_back}}</button>
        <button id="single_page__send"  @click="generate_pdf" class="single_page__button">{{lang.valuation_send}}</button>
    </div>


</div>




</div>
</template>

<script>
import myDatepicker from './vue-datepicker-es6';
import Dropzone from 'vue2-dropzone'
import axios from 'axios';
import $ from 'jQuery'

  import Multiselect from 'vue-multiselect'


function isIE9OrBelow() {
  return /MSIE\s/.test(navigator.userAgent) && parseFloat(navigator.appVersion.split("MSIE")[1]) < 10;
}

$.fn.extend({
  animateCss: function (animationName, callback) {
    if(isIE9OrBelow()){
      if (callback && callback == 'hide') $(this).hide();
      else if(callback) callback();
    }
    $(this).removeClass('animated ' + animationName); //dodano zeby nie nakladaly sie na siebie i blokowaly zakonczenie
    var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
    $(this).unbind(animationEnd);
    $(this).addClass('animated ' + animationName).one(animationEnd, function() {
      $(this).removeClass('animated ' + animationName);
      if (callback && callback == 'hide') $(this).hide();
      else if(callback) callback();
    });
    return this;
  }
});

// do dodawania
var form_dom = $('#single_page_valuation')


export default {
  name: 'app',
  data () {
  return {


    // select
    // select_options: [{value: "CA", label: "Canada"},{value: "PL", label: "Poland"}],
    select_options: [],

    // select_options: ['PL', 'CA'],
    select_country:'',


    pdf_string: '',

    dropzone_translation:{
        dictRemoveFile: lang['upload_remove'],
        dictDefaultMessage: lang['upload_message'],
        dictCancelUpload: lang['upload_cancel'],
        dictFileTooBig: lang['upload_too_big'],
        dictMaxFilesExceeded: lang['upload_too_many'],
    },


    endpoint_url: root_url+'endpoint.php',

    lang: lang,
    current_screen:'car',

    car_brand:'',
    car_number:'',
    car_model:'',
    car_weight:'',

    client_date:'',
    client_city:'',
    client_name:'',
    client_country:'',
    client_street:'',
    client_street_number:'',
    client_postal_code:'',
    client_document_number:'',
    client_document_issued:'',
    client_phone:'',
    client_email:'',

    date: {
      time: '' // string
    },

      datepicker_options: {
        type: 'day',
        week: ['Pon', 'Wt', 'Śr', 'Czw', 'Piąt', 'Sob', 'Ndz'],
        month: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        // inputStyle: {
        //   'display': 'inline-block',
        //   'padding': '6px',
        //   'line-height': '22px',
        //   'font-size': '16px',
        //   'border': '2px solid #fff',
        //   'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
        //   'border-radius': '2px',
        //   'color': '#5F5F5F'
        // },
        // color: {
        //   header: '#ccc',
        //   headerText: '#f00'
        // },
        buttons: {
          ok: 'Ok',
          cancel: 'Anuluj'
        },
        // overlayOpacity: 0.5, // 0.5 as default
        // dismissible: true // as true as default
      },

      // dropzone_options:{
      //   id: 'myVueDropzone',
      //   url: '/endpoint.php',
      //   acceptedFileTypes: 'image/*',
      //   maxFileSizeInMB:10,
      //   maxNumberOfFiles:10,
      // }

      // uploaded_files:[]

  }
},
created() {

  // dodaj styl ze zalladowano formularz

  $('#single_page_valuation').addClass('loaded');


    //juz wypelnione pola
    this.$persist(['car_brand', 'car_number', 'car_model', 'car_weight', 'client_date', 'client_city', 'client_name', 'client_name', 'client_country', 'client_street', 'client_street_number', 'client_postal_code', 'client_document_number', 'client_document_issued', 'client_phone', 'client_email', 'select_country'])

// wybrana data - wstawiaj do pickera

this.date.time = this.client_date


// uzupelnij automatycznie wybrane panstwo


// uzyj tylko wtedy gdy nie wybral juz klient jakiejs opcji wczesniej i nie ma w persistence

// if(this.client_country == '' && this.select_country == ''){

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var selected_country_code = getCookie('country_code');
var selected_country = country_codes[selected_country_code][0]['FIELD2'];

// }

// dla backendu
// zmienia sie potem za pomoca nasluchiwania na event input

if(this.client_country == ''){

    this.client_country = selected_country_code

    this.select_country = {
      value: selected_country_code,
      label: selected_country
    }

}


// stwórz liste krajow label - value

      var sorted_codes = []
        // console.log(country_codes)

        // zwykle foreach nie dziala z jakiego powodu
        $.each(country_codes, function(index, val){
        // country_codes.forEach(function(index, val){
            var insert = {}

            insert['value'] = index
            insert['label'] = val[0]['FIELD2']

            sorted_codes.push(insert)

        })

        // console.log(sorted_codes)
this.select_options = sorted_codes


    //pobierz isntneijace obrazki

    var parameters = {
      action: 'list_files',
    }

    var query_string = $.param(parameters)


    axios.post(this.endpoint_url, query_string )
    .then(response => {

        var files = response.data.files
        var folder = response.data.folder

        var instance = this

        files.forEach(function(val, index){
            var mockFile = { name: val['name'], size: val['size'] };
            var path = root_url+'/email_uploads/'+folder+'/'+val['name']
            instance.$refs.dropzone_ref.manuallyAddFile(mockFile, path)
        })

      })
    .catch(e => {
      console.log(e)
    })



  },

  components: {
    'date-picker': myDatepicker,
    'Dropzone': Dropzone,
    'multiselect': Multiselect,
  },


// watch - uzupelniaj client_date aby mozna bylo uzyc persistance
// persistance dziala tylko na pojedyncze zmienne a nie obiekty (chyba)

watch:{

    'date.time' :function(){
      this.client_date = this.date.time
    },
    'select_country': function(){
      this.client_country = this.select_country.value
    }

},

    methods: {

      'set_code': function(payload){

        // if bo odpalalo na poczatku tez z null
        if(payload['value']){
        this.client_country = payload['value']

        // dla persistence
        this.select_country = payload['label']

      }
      },

      'to_first_screen': function(){

            this.current_screen = 'car'
            $('html, body').animate({scrollTop: 0}, 200);

      },
      'to_second_screen': function(){

            // this.$validator.validateAll()


            // nie waliduj od razu wszystkiego zeby po otwarciu drugiego ekranu nie bylo od razu bledu ze jest pusty
            this.$validator.validateAll({
              car_brand: this.car_brand,
              car_model: this.car_model,
              car_number: this.car_number,
              car_weight: this.car_weight,
            })


            // if(!this.errors.any()){
              // nie moze byc errors any bo przy uzyciu v0show od razu rendueruja ie nastepne i one jako na poczatku niewypelnione maja bledy

              if(!this.errors.has('car_brand') && !this.errors.has('car_model') && !this.errors.has('car_number') && !this.errors.has('car_weight')){

                this.current_screen = 'client'
                $('html, body').animate({scrollTop: 0}, 200);

            }else{
                // console.log('bledziki')
                // console.log(this.errors)
                $('#single_page__next').animateCss('shake');
            }
      },

      'uploaded_file': function(file, response){
             // this.uploaded_files.push({server_name: response.name, app_name: file.name})
             response = JSON.parse(response) // dropzone nie parsuje odpowiedzi do json
             file.previewElement.setAttribute('server_name', response.name);
      },

      'remove_file': function(file, error, xhr){



              var filename = file.name

              // jesli usuwamy plik ktory w tej sesji byl uploadowany i zostala zwrocona inna nazwa
              // inaczej gdy odswieamy zmieniona przez php nazwa juz jest ladowana normalnie

              if(file.previewElement.hasAttribute('server_name')){
                  filename = file.previewElement.getAttribute('server_name')
              }


              var parameters = {
                        action: 'remove_file',
                        name: filename,
                    }

              var query_string = $.param(parameters)

              axios.post(
               this.endpoint_url, query_string
                ).then(response => {
                    // console.log('usunieto z serwera')
                })
                .catch(e => {
                  console.log('nie mozna usunac z serwera')
                })

      },

      'sending_file': function(file, xhr, formData){
        formData.append('action', 'upload_file');
      },

      'send_email': function(){

              var email_data = {
                car_brand: this.car_brand,
                car_model: this.car_model,
                car_number: this.car_number,
                car_weight: this.car_weight,
                client_city: this.client_city,
                client_country: this.client_country,
                client_date: this.client_date,
                client_document_issued: this.client_document_issued,
                client_document_number: this.client_document_number,
                client_email: this.client_email,
                client_name: this.client_name,
                client_phone: this.client_phone,
                client_postal_code: this.client_postal_code,
                client_street: this.client_street,
                client_street_number: this.client_street_number,
              }

              var parameters = {
                        action: 'send_cat',
                        object: this.client_to_base,
                        object_cat_email: email_data,
                        pdf_string: this.pdf_string,
                    }

              var query_string = $.param(parameters)


               // waliduj

               this.$validator.validateAll()

               if(!this.errors.any()){


                 // blokuj upload

                 form_dom.addClass('sending');

                 // oczekiwanie


                  axios.post(
                   this.endpoint_url, query_string
                  ).then(response => {

                    form_dom.removeClass('sending');

                    if(response['data']['send_email_status'] == 'ok'){
                      pnotify( lang['send_ok'] )

                      this.reset_form()



                    }else{
                      // prosimy o kontakt
                      pnotify( lang['send_backend_error'] )
                      // console.log(response)
                    }


                  })
                  .catch(e => {
                    // blad polaczenia
                    pnotify( lang['send_connection_error'] , 'error')
                    console.log(e)
                    form_dom.removeClass('sending');
                  })


               }else{
                pnotify( lang['send_validation_error'] , 'error')
               }



      },

      'reset_form' : function(){

                       //uuzpelnij pozniej
                       this.car_brand = ''
                       this.car_model = ''
                       this.car_number = ''
                       this.car_weight = ''

                       this.client_city = ''
                       this.client_country = ''
                       this.client_document_issued = ''
                       this.client_document_number = ''
                       this.client_email = ''
                       this.client_name = ''
                       this.client_phone = ''
                       this.client_postal_code = ''
                       this.client_street = ''
                       this.client_street_number = ''
                       this.client_city = ''
                       this.client_date = ''
                       this.date.time = ''

                        // nie dziala dla recznie dodanych plikow na poczatku
                       this.$refs.dropzone_ref.removeAllFiles()

                       // usuwamy recznie z dom
                       $('.dz-preview').remove()

                       // przy czyszczeniu pojawi sie bledy
                       this.errors.clear();

                       // do 1 ekranu
                       this.current_screen = 'car'
      },

      'generate_pdf' : function(type){


        this.$validator.validateAll()

        if(!this.errors.any()){


          // blokuj juz przy generowaniu
          form_dom.addClass('sending')


          var date = new Date;
          var now_date = date.getDate()+'-'+date.getMonth()+'-'+date.getFullYear();
          // var form_date = checkVal($('#form_date', $form));

          // tymczasowo
          var form_date = this.client_date

          var form_city = this.client_city
          var form_name = this.client_name
          var form_street = this.client_street
          var form_street_number = this.client_street_number
          var form_postal_code = this.client_postal_code

          var form_marka = this.car_brand
          var form_number = this.car_number
          var form_model = this.car_model
          var form_weight = this.car_weight
          var form_country = this.client_country
          var form_passport_number = this.client_document_number
          var form_gifted = this.client_document_issued
          var form_phone = this.client_phone
          var form_email = this.client_email


          var line_height = 1.2;

          var docDefinition = {
            pageSize: 'A4',
            background:
              { image: image_logo, width: 540, margin: [30, 300, 30, 300] },
            content:
              [
                { image: image_bg, width: 250 },
                { text: 'UMOWA KUPNA SPRZEDAŻY', style: 'header', margin: [ 0, 50, 0, 30 ] },
                { text: 'W dniu '+now_date+' w Mińsku Mazowieckim pomiędzy: ', margin: [ 0, 0, 0, 20 ], lineHeight: line_height },
                { text: form_name+', zamieszkały ul.'+form_street+' '+form_street_number+', '+form_postal_code+' '+form_city+', '+form_country+', legitymujący się dowodem osobistym nr '+form_passport_number+', wydanym przez: '+form_gifted+' zwanym dalej sprzedawcą, ', margin: [ 0, 0, 0, 20 ], lineHeight: line_height },
                { text: 'a Valdi Katalizatory - Skup katalizatorów, ul. Średnia 5, 05-555 Tarczyn, NIP: 7971504304 zwanym dalej kupującym została sporządzona niniejsza umowa. ', margin: [ 0, 0, 0, 20 ], lineHeight: line_height },
                { text: '1. Sprzedawca zobowiązuje się, że do dnia '+form_date+' dostarczy kupującemu następujący towar: katalizator o nr '+form_model+' pochodzący z auta '+form_marka+'.', lineHeight: line_height },
                { text: '2. Wynagrodzenie za towar strony ustaliły w wysokości ………………………… PLN.', lineHeight: line_height },
                { text: '3. Kupujący zobowiązuje się do odbioru dostarczonego towaru i zapłaty ceny.', lineHeight: line_height },
                { text: '4. Strony ustalają, że towar nie zostanie odebrany do czasu, gdy Kupujący dokona jego oględzin i stwierdzi, że jest on zgodny z zamówieniem.', lineHeight: line_height },
                { text: '5. Kupujący stwierdza, że cenę za dostarczony towar uiści w miejscu odbioru.', lineHeight: line_height },
                { text: '6. Towar uważa się za odebrany z chwilą jego dostarczenia na adres Kupującego, wymieniony w niniejszej umowie.', lineHeight: line_height },
                { text: '7. Do czasu odbioru towaru przez Kupującego ryzyko związane z utratą lub uszkodzeniem towaru ponosi Sprzedawca.', lineHeight: line_height },
                { text: '8. Sprzedawca oświadcza, że nie istnieją ani nie są wysuwane jakiekolwiek roszczenia osób trzecich podważające wiarygodność niniejszej umowy. Sprzedawca oświadcza, że towar wolny jest od wszelkich wad prawnych i fizycznych.', lineHeight: line_height },
                { text: '9. Kupujący posiada prawo do zbadania dostarczonego towaru i poinformowania Sprzedawcy w terminie 10 dni roboczych o jakichkolwiek stwierdzonych wadach, ubytkach lub uszkodzeniach. W przypadku ich nie zgłoszenia, uważa się że towar został odebrany bez zastrzeżeń', lineHeight: line_height },
                { text: '10. Sprzedający podpisując umowę deklaruje, iż sprzedawany towar nie pochodzi z działalności przestępczej (np. kradzież, paserstwo).', lineHeight: line_height },
                { text: '11. niniejszym umowa została sporządzona w dwóch jednobrzmiących egzemplarzach po jednym dla każdej ze stron. ', lineHeight: line_height },
                {
                columns: [
                  {
                    width: '50%',
                    text: 'Podpis Sprzedającego',
                    style: 'column_left',
                    margin: [0, 30, 0, 0]
                  },
                  {
                    width: '50%',
                    text: 'Podpis Kupującego',
                    style: 'column_right',
                    margin: [0, 30, 0, 0]
                  }
                ],
                columnGap: 0
              },
            ],
            styles: {
              header: {
                fontSize: 20,
                bold: true,
                alignment: 'center'
              },
              column_left: {
                alignment: 'left'
              },
              column_right: {
                alignment: 'right'
              }
            }
          };


      var instance = this


      //      pobierz
      var date = new Date;
      date = date.getSeconds()+'-'+date.getDate()+'-'+date.getMonth()+'-'+date.getFullYear();
      pdfMake.createPdf(docDefinition).download('umowa-'+form_marka+'-'+date);


      // otworz w nowymokienku
      // pdfMake.createPdf(docDefinition).open({}, window.open('', '_blank'))

       // przekaz string umowy
      pdfMake.createPdf(docDefinition)
      .getDataUrl(function(data) {

        instance.pdf_string = data
        instance.send_email()


      })

}else{
   $('#single_page__send').animateCss('shake');
}


      }


    },

    computed:{

      client_to_base: function(){


            // vue persistence nie chce akceptowac obiektow a jedynie zmiienne wiec tworze osobny obiekt ktory jest wysylany do backendu zamist umiescic go bezposrednio w data
            var object = {
                  name:this.client_name,
                  email:this.client_email,
                  phone: this.client_phone,
                  city: this.client_city,
                  postalCode:this.client_postal_code,
                  street:this.client_street,
                  streetNumber:this.client_street_number,
                  country: this.client_country,
                  type: 'cat-form', // zeby baza rozpoznawala ze to z formularza cat
            }

            return object
      }

    }


}
</script>

<style>

.vue-dropzone{
    width:800px;
}

.material-icons{
  display: none;
}

</style>



// WEBPACK FOOTER //
// form.vue?4fb142b2